import { FaFacebookF, FaInstagram, FaRegEnvelope } from 'react-icons/fa';
import styles from '../../page.module.scss';
import Link from 'next/link';

interface SocialIconsProps {
  className?: any;
}

const SocialIcons: React.FC<SocialIconsProps> = ({ className }) => {
  return (
    <div className={styles.iconsContainer}>
      <Link href={'https://www.facebook.com/lalibrelibreria/'} target="_blank">
        <div className={`${styles.socialIcon} ${className && className}`}>
          <FaFacebookF />
        </div>
      </Link>
      <Link href={'https://www.instagram.com/lalibrearteylibros/'} target="_blank">
        <div className={`${styles.socialIcon} ${className && className}`}>
          <FaInstagram />
        </div>
      </Link>
      <a href={'mailto:lalibrearteylibros@gmail.com'} target="_blank">
        <div className={`${styles.socialIcon} ${className && className}`}>
          <FaRegEnvelope />
        </div>
      </a>
    </div>
  );
};

export default SocialIcons;
